import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-submit-fail-dialog',
  templateUrl: './submit-fail-dialog.component.html',
  styleUrls: ['./submit-fail-dialog.component.scss']
})
export class SubmitFailDialogComponent {
  isWithEHailing = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isWithEHailing?: boolean;
      insuranceType: string;
      isVehicleUnderAged: boolean;
      isVehicleOverAged: boolean;
    },
    public translate: TranslateService
  ) { 
    if (data.isWithEHailing) this.isWithEHailing = data.isWithEHailing;
  }

  onBackToHome(): void {
		window.location.href = "/";
	}
}
